export default class SiteHeader {
  init() {
    this.siteHeaderElement = document.getElementById('site-header');
    this.backToTopButton = document.querySelector('.back-to-top');

    if (!this.siteHeaderElement) {
      return;
    }

    this.searchToggleButton = this.siteHeaderElement.querySelector(
      '.site-header__search-button'
    );

    this.searchForm = this.siteHeaderElement.querySelector(
      '.site-header__search-form'
    );

    this.searchFormInput = this.searchForm.querySelector(
      'input[type="search"]'
    );

    this.searchSubmitButton = this.searchForm.querySelector(
      'button[type="submit"]'
    );

    if (this.searchToggleButton && this.searchSubmitButton && this.searchForm) {
      this.searchToggleButton.addEventListener(
        'click',
        () => {
          this.toggleSearchForm();
        },
        window.supportPassive
      );

      this.searchSubmitButton.addEventListener('click', (e) => {
        e.preventDefault();

        if (this.searchFormInput.value && this.searchFormInput.value.length) {
          this.searchForm.submit();

          return;
        }

        this.toggleSearchForm(false);
        this.searchToggleButton.focus({ focusVisible: true });
      });
    }

    this.burgerButton = this.siteHeaderElement.querySelector(
      '.site-header__burger-button'
    );

    this.mainMenuItemButtons = Array.from(
      this.siteHeaderElement.querySelectorAll(
        '.site-header__main-menu-item-button'
      )
    );

    this.mainMenuPanelCloseButtons = Array.from(
      this.siteHeaderElement.querySelectorAll(
        '.site-header-panel__close-button'
      )
    );

    this.burgerButton.addEventListener(
      'click',
      () => {
        const force = !this.burgerButton.classList.contains(
          'burger-menu-is-active'
        );

        this.burgerButton.classList.toggle('burger-menu-is-active', force);

        this.toggleBurgerMenu(force);

        if (!force) {
          this.disabledAllActiveElements();

          this.checkIfOnePanelIsActive();
        }
      },
      window.supportPassive
    );

    for (const button of this.mainMenuItemButtons) {
      button.addEventListener(
        'click',
        () => {
          if (button.classList.contains('is-active')) {
            this.togglePanel(button);
          } else {
            this.disabledAllActiveElements();

            this.togglePanel(button);
          }
        },
        window.supportPassive
      );
    }

    for (const closeButton of this.mainMenuPanelCloseButtons) {
      closeButton.addEventListener(
        'click',
        () => {
          this.togglePanel(closeButton, false);
        },
        window.supportPassive
      );
    }

    this.anchor = document.getElementById('site-header-anchor');

    if (this.anchor) {
      const anchorObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.siteHeaderElement.classList.toggle(
              'is-fixed',
              !entry.isIntersecting
            );
            this.backToTopButton.classList.toggle(
              'back-to-top--is-active',
              !entry.isIntersecting
            );

            if (entry.isIntersecting) {
              this.backToTopButton.setAttribute('tabindex', '-1');
            } else {
              this.backToTopButton.removeAttribute('tabindex');
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 1,
        }
      );

      anchorObserver.observe(this.anchor);
    }
  }

  toggleSearchForm(force = undefined) {
    force =
      force === undefined
        ? !this.searchToggleButton.classList.contains('search-form-is-active')
        : force;

    this.searchForm.classList.toggle('search-form-is-active', force);
    this.searchToggleButton.classList.toggle('search-form-is-active', force);
    this.siteHeaderElement.classList.toggle('search-form-is-active', force);

    if (force) {
      this.searchFormInput.focus();
    }
  }

  disabledAllActiveElements() {
    Array.from(this.siteHeaderElement.querySelectorAll('.is-active')).forEach(
      (element) => {
        element.classList.remove('is-active');
      }
    );
  }

  toggleBurgerMenu(force = undefined) {
    force =
      force === undefined
        ? !this.siteHeaderElement.classList.contains('has-burger-menu-active')
        : force;

    this.siteHeaderElement.classList.toggle('has-burger-menu-active', force);
  }

  togglePanel(button, force = undefined) {
    const panel = document.getElementById(button.dataset.panelTarget);

    const otherButtons = Array.from(
      this.siteHeaderElement.querySelectorAll(
        `[data-panel-target="${button.dataset.panelTarget}"]`
      )
    );

    force =
      force === undefined ? !button.classList.contains('is-active') : force;

    button.classList.toggle('is-active', force);
    button.blur();
    panel.classList.toggle('is-active', force);

    for (const otherButton of otherButtons) {
      otherButton.classList.toggle('is-active', force);

      if (
        !force &&
        otherButton.classList.contains('site-header__main-menu-item-button')
      ) {
        otherButton.focus();
      } else if (force) {
        panel.focus();
      }
    }

    this.checkIfOnePanelIsActive();
  }

  checkIfOnePanelIsActive() {
    const openPanels = Array.from(
      this.siteHeaderElement.querySelectorAll('.is-active')
    );

    this.siteHeaderElement.classList.toggle(
      'has-one-panel-active',
      openPanels.length > 0
    );
  }
}
